(function(){
'use strict';
var config=document.querySelector('[data-edg-buckle-replacement]');
if(!config)return;
function replacement(value){
 if(!value)return '';
 if(/(?:\/buckle(?:_[0-9]+x[0-9]*)?\.png|\/FMT-TACTICAL-BUCKLE-DETAIL(?:_[0-9]+x[0-9]*)?\.png)/i.test(value))return config.dataset.edgBuckleReplacement;
 if(/\/edg-harness-concept(?:_[0-9]+x[0-9]*)?\.jpg/i.test(value))return config.dataset.edgHarnessReplacement;
 return '';
}
function update(root){
 var nodes=[];
 if(root.nodeType===1&&root.matches('img,source,a'))nodes.push(root);
 if(root.querySelectorAll)nodes=nodes.concat(Array.from(root.querySelectorAll('img,source,a')));
 nodes.forEach(function(el){
 ['src','srcset','data-src','data-srcset','href'].forEach(function(attr){
 var target=replacement(el.getAttribute(attr));if(!target)return;
 el.setAttribute(attr,target);
 if(el.tagName==='IMG'){el.removeAttribute('srcset');el.style.objectFit='contain';}
 });
 });
}
update(document);
new MutationObserver(function(records){records.forEach(function(r){if(r.type==='attributes')update(r.target);else r.addedNodes.forEach(update);});}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','data-src','data-srcset','href']});
})();